import { IScriptObject } from "../../../../../domain/editableFormat/objects";
import { IScriptObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import {
  PrintBehaviorTranslator,
  EditBehaviorTranslator,
  PageExtendBehaviorTranslator,
  InputMethodBehaviorTranslator,
  TurnedTextStyleTranslator,
  ScriptTableBehaviorTranslator,
} from "./properties";
import { StandardTextDrawableObjectTranslator } from "./base";

export class ScriptObjectTranslator extends AbstractObjectTranslator<IScriptObject, IScriptObjectBean> {
  constructor() {
    super(new StandardTextDrawableObjectTranslator());
  }

  protected shouldRecordName(source: IScriptObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IScriptObject, bean: IScriptObjectBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.editBehavior = this.editBehavior.from(bean);
    source.pageExtendBehavior = this.pageExtendBehavior.from(bean);
    source.inputMethodBehavior = this.inputMethodBehavior.from(bean);
    source.turnedTextStyle = this.turnedTextStyle.from(bean);
    // @ext-keyは対応しない.(大昔にがん登録向けに実装していたが実際に使われてはいない模様.今となってはどう使うかの想定も不明.)
    source.scriptTableBehavior = this.scriptTableBehavior.from(bean);
  }

  overwriteBean(source: IScriptObjectBean, object: IScriptObject): void {
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@vanish"] = this.editBehavior.to(object).vanish;
    const pageExtendBehavior = this.pageExtendBehavior.to(object);
    source["@auto-notepage-size"] = pageExtendBehavior.autoNotepageSize;
    source["@auto-notepage-type"] = pageExtendBehavior.autoNotepageType;
    source["@auto-notepage-overwrite"] = pageExtendBehavior.autoNotepageOverwrite;
    source["@input-code"] = this.inputMethodBehavior.to(object).inputCode;
    source["@asterisk"] = this.turnedTextStyle.to(object).asterisk;
    // @ext-keyは対応しない.(大昔にがん登録向けに実装していたが実際に使われてはいない模様.今となってはどう使うかの想定も不明.)
    const scriptTableBehavior = this.scriptTableBehavior.to(object.scriptTableBehavior);
    source["@exe-path"] = scriptTableBehavior.exePath;
    source["@csv-path"] = scriptTableBehavior.csvPath;
    source["@update"] = scriptTableBehavior.update;
    source["@split"] = scriptTableBehavior.split;
    source["@before-value"] = undefined;  // フォーマット編集では設定しない.(文書編集用.)
    source["@before-value-path"] = scriptTableBehavior.beforeValuePath;
    source["@value-path"] = scriptTableBehavior.valuePath;
    source["@row"] = scriptTableBehavior.row;
    source["@column"] = scriptTableBehavior.column;
    source["@input-value-path"] = scriptTableBehavior.inputValuePath;
    source.scriptitem = scriptTableBehavior.scriptitem;
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly editBehavior = new EditBehaviorTranslator();
  private readonly pageExtendBehavior = new PageExtendBehaviorTranslator();
  private readonly inputMethodBehavior = new InputMethodBehaviorTranslator();
  private readonly turnedTextStyle = new TurnedTextStyleTranslator();
  private readonly scriptTableBehavior = new ScriptTableBehaviorTranslator();
}
